import { render, staticRenderFns } from "./SaleOrd.vue?vue&type=template&id=d84decc0"
import script from "./SaleOrd.vue?vue&type=script&lang=js"
export * from "./SaleOrd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d84decc0')) {
      api.createRecord('d84decc0', component.options)
    } else {
      api.reload('d84decc0', component.options)
    }
    module.hot.accept("./SaleOrd.vue?vue&type=template&id=d84decc0", function () {
      api.rerender('d84decc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Decocting/SaleOrd.vue"
export default component.exports